/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API48189Req {
  
  /** 任务id */
  taskId?: number;
  /** 任务标题 */
  taskTitle?: string;
  /** 任务内容描述 */
  taskDesc?: string;
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  /** 执行人用户id列表 ,String */
  taskExecutorIdList?: any[];
  /** 抄送人用户id列表 ,String */
  taskCcIdList?: any[];
  /** 完成标准(1:或签,2:会签，默认1)，详见TaskCompleteTypeEnum */
  taskCompleteType?: number;
  /** 计划开始时间yyyy-MM-ddHH:mm:ss */
  startTime?: any;
  /** 计划开始时间yyyy-MM-ddHH:mm:ss */
  endTime?: any;
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  /** 能否处理已逾期的任务 */
  canExecOverdue?: boolean;
  /** 消息提醒规则，from数据字典，默认no_notify不提醒 */
  notifyRule?: string;
};



export interface API48189Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 48189 修改任务

export interface IUsePostAPI48189Return {
  /** 修改任务: 接口请求状态 */
  isAPI48189Loading: boolean;
  /** 修改任务: 接口请求返回数据 */
  dataAPI48189: API48189Res;
  /**  修改任务: 接口数据请求方法 */
  fetchAPI48189Data:  (inputs: API48189Req, config?: YWRequestConfig) => Promise<API48189Res>;
  /** 修改任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48189 = ():IUsePostAPI48189Return => {
  let isMount = true;
  const [isAPI48189Loading, setIsAPI48189Loading] = useState(false);
  const [dataAPI48189, setDataAPI48189] = useState<API48189Res>({} as API48189Res);
  const requestUrl = `${basePath}/team-work/workTask/modifyWorkTask`;

  const fetchAPI48189Data = async (inputs: API48189Req, config?: YWRequestConfig): Promise<API48189Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48189Req>) || {}) as API48189Req;
    
  
    if ( isMount ) {
      setIsAPI48189Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48189Res>(`${basePath}/team-work/workTask/modifyWorkTask`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48189(res || {} as API48189Res);
        setIsAPI48189Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48189Loading(false);
      }
      return false as unknown as API48189Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48189Loading,
    dataAPI48189,
    fetchAPI48189Data,
    requestUrl,
  }
}

